import { createAsyncThunk } from '@reduxjs/toolkit';
import { APIErrorMessage } from '../../../../../shared/infra/api/APIErrorMessage';
import { GetScheduledNotificatonReqeustDTO } from '../../dtos/Notifications.dto';
import { NotificationModel } from '../../models/Notifications.model';
import { notificationService } from '../../services';

const getScheduledNotifications = createAsyncThunk<
  NotificationModel[],
  GetScheduledNotificatonReqeustDTO,
  { rejectValue: APIErrorMessage }
>('notifications/getScheduledNotifications', async (query, thunkapi) => {
  const { startDate, endDate } = query;

  const result = await notificationService.getScheduledNotifications(
    startDate,
    endDate,
  );

  if (result.isLeft()) {
    const error = result.value;
    return thunkapi.rejectWithValue(error);
  } else {
    return result.value.getValue();
  }
});

export default getScheduledNotifications;
